// The theme a signed-out visitor sees on the platform's public site.
//
// The auth context's default style (black + pink) is a signed-in user's starting point, and
// was also what every prospect saw on the marketing pages. Ross chose a light theme with a
// teal accent for visitors (2026-10-04). A partner host still re-tints it: App.jsx applies
// the partner's brand colours on top of whatever preset this returns.
//
// Not applied:
// - before auth has settled, so a signed-in user never flashes through the visitor theme;
// - on the Fettes host, whose sign-in pages keep their existing look.

export const VISITOR_STYLE = Object.freeze({
    theme: 'white',
    colorPreset: 'teal',
    // The marketing CTAs on the dark teal bands are `color="secondary"`. The white theme
    // defines no secondary, so MUI's default purple showed through. White with teal text,
    // and a pale teal hover rather than the grey MUI would derive from white. A partner's
    // own secondary colour still wins (App.jsx).
    secondary: Object.freeze({
        main: '#FFFFFF',
        dark: '#CCFBF1',
        contrastText: '#115E59'
    })
})

/** The style App.jsx should build its theme from. */
export function effectiveStyle(
    style,
    { isInitialized, isAuthenticated, isFettes }
) {
    if (!isInitialized || isAuthenticated || isFettes) {
        return style
    }
    return { ...style, ...VISITOR_STYLE }
}

/**
 * The brand colours App.jsx lays over the theme. A partner's colours apply everywhere on its
 * host. A platform brand's (Joulelingo green, Kilosight blue) apply only to signed-out pages,
 * so inside the app every user keeps the accent they picked (Ross, 2026-11-03).
 */
export function brandColours(brand, { isAuthenticated }) {
    if (isAuthenticated && !brand.is_partner) return {}
    return { primary: brand.primary_color, secondary: brand.secondary_color }
}
